export const termPolicyData = [
  {
    title: "Introduction",
    texts: [
      "These terms and conditions govern your use of this website; by using this website, you accept these terms and conditions in full. If you disagree with these terms and conditions or any part of these terms and conditions, you must not use this website.",
    ],
  },
];
